<template>
  <Loader :loading="loading">
    <section class="service-selector-container">
      <ul class="service-list">
        <li
          :class="{
            active: serviceInView && service.id === serviceInView.id,
            selected: isSelected(service),
          }"
          @click="changeService(service)"
          v-for="service in availableServices"
          :key="service.id"
          ref="item"
        >
          {{ service.name }}
          <span class="remove-service" @click="removeFromReservation(service)"
            >&times;</span
          >
        </li>
      </ul>

      <Service
        :serviceInView="serviceInView"
        :selectedServices="selectedServices"
        @serviceChange="serviceChange"
        @selectedChange="selectedChange"
        @removeFromReservation="removeFromReservation"
        ref="serviceDetail"
      ></Service>
    </section>
  </Loader>
</template>

<script>
import api from "@/services/api-service";
import t from "@/services/translation-service";
import Service from "@/components/Service";
import Loader from "./Loader.vue";
import utils from "@/services/utils.js";
import Vue from "vue";

export default {
  name: "ServiceSelector",
  components: {
    Service,
    Loader,
  },
  props: {
    provider: Object,   
  },
  watch: {
    selectedServices() {},
    provider(newVal) {
      this.updateServices(newVal);
    },
  },
  data() {
    return {
      loading: true,
      availableServices: [],
      selectedServices: [],
      t: t,
      serviceInView: undefined,
      isInitialLoad: true
    };
  },

  methods: {
    isSelected(service) {
      return this.selectedServices.some((s) => s.uniqueKey === service?.uniqueKey);
    },
    changeService(service, delay) {
      this.serviceInView = service;
      this.serviceInView.selectedOptions =
        this.serviceInView.selectedOptions || [];
      this.serviceInView.givenAnswers = this.serviceInView.givenAnswers || [];
      setTimeout(() => {
        const el = this.$refs.serviceDetail.$el;
        el.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }, delay ?? 10);
    },
    htmlDecode: utils.htmlDecode,
    serviceChange(service) {
      const sIndex = this.availableServices.findIndex(
        (f) => f.id === service.id
      );
      Vue.set(this.availableServices, sIndex, service);
      this.serviceInView = this.availableServices[sIndex];
    },
    selectedChange(selected) {
      this.selectedServices = selected;
      this.$emit("change", selected);
    },
    clearData() {
      this.selectedChange([]);
    },
    removeFromReservation(service) {
      const selected = utils.clone(
        this.selectedServices.filter((s) => s.id !== service.id)
      );
      this.selectedChange(selected);
    },
    fixItemsWidths() {
      if (!this.$refs.item) {
        return;
      }
      this.$refs.item.forEach((el) => (el.style.maxWidth = "unset"));
      const firstItemWidth = this.$refs.item[0].clientWidth;
      for (let i = this.$refs.item.length - 1; i >= 0; i--) {
        if (Math.abs(firstItemWidth - this.$refs.item[i].clientWidth) > 5) {
          this.$refs.item[i].style.maxWidth = firstItemWidth + 3 + "px";
        }
      }
    },
    updateServices(provider) {
      this.loading = true;
      const vm = this;
      const queryParams = new URLSearchParams(window.location.search);
      const addServiceKeys = queryParams.get("addServiceKeys")?.split(",");
      const serviceKey = queryParams.get("service") ?? undefined;
      api
        .getServices(provider?.id, addServiceKeys)
        .then((data) => {
          this.availableServices = data
            .map((f) => {
              f.selectedServices = [];
              return f;
            })
            .sort((a, b) => {
              return a.order - b.order;
            });
        })
        .catch((error) => console.log(error.response))
        .finally(() => {
          this.loading = false;
          this.$nextTick(vm.fixItemsWidths);          
          if(this.isInitialLoad && serviceKey){
            const preSelectedService = this.availableServices.find(f => !!f.uniqueKey && f.uniqueKey.toLowerCase() === serviceKey.toLowerCase());
            if(preSelectedService?.id){
              this.changeService(preSelectedService,750)
            }
          }
          this.isInitialLoad = false;
        });
    },
  },
  setSelectedServices(services){
    this.selectedServices.splice(0);
    (services ?? []).map(s =>{
      this.selectedServices.push(s);
    });
  },
  mounted() {
    const vm = this;
    window.addEventListener("resize", vm.fixItemsWidths);
  },
  created() {
    this.updateServices(this.provider);
  },
};
</script>

<style scoped>
.service-list {
  list-style: none;
  display: block;
  padding: 0;
  margin-right: -1rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.service-list li {
  display: flex;
  padding: 0.4rem 1.2rem;
  border: 0.1rem solid grey;
  border-radius: 0.5rem;
  margin: 0 1rem 1rem 0;
  flex-grow: 1;
  flex-basis: 0;
  text-align: center;
  min-width: 180px;
  min-height: 60px;
  align-items: center;
  justify-content: center;
  position: relative;
}

.remove-service {
  display: none;
  position: absolute;
  top: -2px;
  right: 5px;
}
.selected .remove-service {
  display: inline-block;
}
.service-list li:hover {
  cursor: pointer;
  background-color: lightgrey;
}
.service-list li.active {
  background-color: #0047bb;
  color: white;
}
.service-list li.selected {
  background-color: #28a745;
}
</style>
